import queryString from 'query-string';

import { trackUserEvent } from 'api/trackedUserEvents';
import type { ApiOrgId } from 'api/types/ApiTypedId';
import type { ListingType } from 'types/ListingType';
import { trackPageView } from 'utils/analytics/track/trackPageView';
import { listingTypeTrackingName } from 'utils/constants/general/listingTypeTrackingName';
import type { OrgType } from 'utils/constants/general/orgTypes';

type TrackListingStatus = 'published' | 'expired' | 'unpublished';

export function getTrackingTitle(
  status: TrackListingStatus,
  trackingName: string,
) {
  switch (status) {
    case 'published':
      return `${trackingName} Listing Page`;
    case 'unpublished':
      return 'Unpublished Listing Page';
    case 'expired':
      return 'Expired Listing Page';
  }
}

type Args = {
  status: TrackListingStatus;
  hasAts: boolean;
  listingName: string;
  listingId: string;
  listingType: ListingType;
  orgId: ApiOrgId | undefined;
  orgName: string | undefined;
  orgType: OrgType | undefined;
};

export function trackListing({
  status,
  hasAts,
  listingName,
  listingId,
  orgId,
  orgType,
  listingType,
}: Args) {
  const trackingName = listingTypeTrackingName[listingType];
  const trackingTitle = getTrackingTitle(status, trackingName);

  trackPageView(trackingTitle, {
    name: listingName,
    id: listingId,
    org_id: orgId,
    org_type: orgType,
    page_type: `${trackingName} Listings`,
    has_ats: hasAts,
  });

  const queryParams = queryString.parse(window.location.search);
  const utmSource = queryParams.utm_source;
  const utmCampaign = queryParams.utm_campaign;

  if (utmSource && hasAts) {
    trackUserEvent({
      eventName: 'LISTING_REFERRAL',
      extraData: {
        url: window.location.href,
        listingType,
        listingId,
        utmSource,
        utmCampaign,
      },
    });
  }

  if (utmCampaign === 'contact-suggested-applicant') {
    trackUserEvent({
      eventName: 'CONTACT_SUGGESTED_APPLICANT_CLICK',
      extraData: {
        url: window.location.href,
        listingType,
        listingId,
      },
    });
  }
}
